import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { fetchObjectTypeCounts } from '../redux/migrationThunks';
import { OBJECT_TYPE_ICONS } from '../constants/migrationConstants';
import { SAILPOINT_DATA_OBJECT_TYPES, OIM_DATA_OBJECT_TYPES, REMOVE_OIM_CONFIG_MIGRATION_OBJECTS, REMOVE_SAILPOINT_CONFIG_MIGRATION_OBJECTS } from '../constants/objectTypes';

function useObjectTypeCounts(sourceId, sourceType) {
  const dispatch = useDispatch();
  const [objectTypeCounts, setObjectTypeCounts] = useState({});
  const [automatedMigration, setAutomatedMigration] = useState([]);
  const [assistedMigration, setAssistedMigration] = useState([]);
  const [countObject, setCountObject] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCounts = async () => {
      if (!sourceId) return;
      
      try {
        setLoading(true);
        setError(null);
        const countsData = await dispatch(fetchObjectTypeCounts({ 
          sourceId, 
          sourceType 
        })).unwrap();
        
        // Handle nested API response structure
        const dataArray = countsData?.data || countsData;
        
        if (!Array.isArray(dataArray)) {
          return;
        }
        
        const mapObjectType = (item) => ({
          type: item.objectType,
          icon: OBJECT_TYPE_ICONS[item.objectType] || '⚙️',
          label: item.objectType.replace(/([A-Z])/g, ' $1').trim(),
          description: `Migrate ${item.objectType.toLowerCase()} configurations`
        });

        let automated;
        let assisted;
        if (sourceType?.includes('oim')) {
          automated = dataArray
            .filter(item => OIM_DATA_OBJECT_TYPES.includes(item.objectType) && 
                           !REMOVE_OIM_CONFIG_MIGRATION_OBJECTS.includes(item.objectType))
            .map(mapObjectType);

          assisted = dataArray
            .filter(item => !OIM_DATA_OBJECT_TYPES.includes(item.objectType) && 
                           !REMOVE_OIM_CONFIG_MIGRATION_OBJECTS.includes(item.objectType))
            .map(mapObjectType);
        } else {
          automated = dataArray
            .filter(item => SAILPOINT_DATA_OBJECT_TYPES.includes(item.objectType) &&
                           !REMOVE_SAILPOINT_CONFIG_MIGRATION_OBJECTS.includes(item.objectType))
            .map(mapObjectType);

          assisted = dataArray
            .filter(item => !SAILPOINT_DATA_OBJECT_TYPES.includes(item.objectType) &&
                           !REMOVE_SAILPOINT_CONFIG_MIGRATION_OBJECTS.includes(item.objectType))
            .map(mapObjectType);
        }
        
        setAutomatedMigration(automated);
        setAssistedMigration(assisted);
        setCountObject(dataArray);
        
        const countMap = {};
        dataArray.forEach((item) => {
          countMap[item.objectType] = item.count;
        });
        setObjectTypeCounts(countMap);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    
    loadCounts();
  }, [sourceId, sourceType, dispatch]);

  return { objectTypeCounts, automatedMigration, assistedMigration, countObject, loading, error };
}

export default useObjectTypeCounts;
